import React from 'react';
import BulkCategoryUploadTool from './BulkCategoryUploadTool';
import BulkCustomFieldOptionsUpload from './BulkCustomFieldOptionsUpload';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { enqueueSnackbarCustomMessage } from 'actions/Snackbar/resetSnackbar';
import BulkDepartmentUploadTool from './BulkDepartmentUpload';
import SSOIntegrationSetupManager from 'components/SSOIntegrationSetup';
import HrisManager from 'components/HrisManager';

type Props = {
  enqueueSnackbarCustomMessage: Function;
  organizationId: string;
};

function SupportTools(props: Props) {
  return (
    <div>
      <BulkCategoryUploadTool
        enqueueSnackBarMessage={props.enqueueSnackbarCustomMessage}
        organizationId={props.organizationId}
      />
      <BulkCustomFieldOptionsUpload
        enqueueSnackBarMessage={props.enqueueSnackbarCustomMessage}
        organizationId={props.organizationId}
      />
      <BulkDepartmentUploadTool  
        enqueueSnackBarMessage={props.enqueueSnackbarCustomMessage}
        organizationId={props.organizationId}
      />
      <HrisManager 
        enqueueSnackBarMessage={props.enqueueSnackbarCustomMessage}
        organizationId={props.organizationId}
      />
      <SSOIntegrationSetupManager 
        enqueueSnackBarMessage={props.enqueueSnackbarCustomMessage}
        organizationId={props.organizationId}
      />
    </div>
  );
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      enqueueSnackbarCustomMessage,
    },
    dispatch,
  );
}
export default connect(null, mapDispatchToProps)(SupportTools);
